import(/* webpackMode: "eager" */ "/vercel/path0/app/quiz/page.tsx");
